var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('image-card',{staticClass:"image"}),_c('blurb-component',{staticClass:"blurb"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }